// @ts-check
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import {
  shade, color, spacing
} from '@codex-brightworld/themes';

const TextAreaElement = styled.textarea.attrs(props => ({ 'data-qa': props.qa }))`
  border-radius: 4px;
  box-shadow: none;
  outline: none;
  width: 100%;
  min-height: 118px;
  margin: 0;
  font-size: 13px;

  ${({
    theme, value, valid, disabled
  }) => css`
    color: ${theme.colors.shades[1]};
    padding: 13px ${theme.spacing[4]};
    ${!value && `border: 1px solid ${theme.colors.shades[5]}`};
    ${value && valid && `border: 1px solid ${theme.colors.positive.accent}`};
    ${!valid && `border 1px solid ${theme.colors.error.accent}`};
  };

    ${disabled && `background-color: ${theme.colors.shades[6]}`};

    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 4px;
      background-color: ${theme.colors.shades[6]};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: ${theme.colors.shades[5]};
    }

    &:focus{
      border: 1px solid ${theme.colors.focusedAccent};
      outline: none;
    }
  `};
`;

const ValidationMessage = styled.div`
  margin: ${spacing(1)} 0;
  font-size: 12px;
  color: ${color('error', 'default')};
  transition: color 0.2s;

  ${TextAreaElement}:focus ~ & {
    color: ${shade(0)}
  }
`;

const TextArea = ({
  className, validationMessage, valid, placeholderText, ...rest
}) => (
  <div className={className}>
    <TextAreaElement valid={valid} placeholder={placeholderText} {...rest} />

    {validationMessage && !valid &&
    <ValidationMessage>{validationMessage}</ValidationMessage>}
  </div>
);

TextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  validationMessage: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  qa: PropTypes.string
};

TextArea.defaultProps = {
  className: '',
  disabled: false,
  name: null,
  placeholderText: '',
  validationMessage: '',
  valid: true,
  value: '',
  onBlur: null,
  onChange: null,
  onClear: null,
  onFocus: null,
  onKeyDown: null,
  qa: undefined
};

/** @component */
export default TextArea;
